<template>
  <div class="bilingual-news">
    <BackToTop />
    <div class="container">
      <div class="main">
        <div class="main_left">
          <div class="title">
            {{
              currentLang === "en"
                ? newsDetail.title_en || "-"
                : newsDetail.title
            }}
          </div>
          <div class="information">
            <div class="information_left">
              <li class="time">{{ formatTime(newsDetail.create_time) }}</li>
              <li class="laiyuan" v-if="currentLang === 'en'">
                Source：<span>{{ newsDetail.source_en || "-" }}</span>
              </li>
              <li class="laiyuan" v-else-if="newsDetail.source">
                来源：<span>{{ newsDetail.source }}</span>
              </li>
            </div>
            <div class="information_right" v-if="currentLang === 'en'">
              Editor / {{ newsDetail.author_en || "-" }}
            </div>
            <div class="information_right" v-else-if="newsDetail.author">
              作者： {{ newsDetail.author }}
            </div>
          </div>
          <div class="info" v-if="currentLang === 'en'">
            <li class="shuxian"></li>
            <li class="info_title">Summary：</li>
            <li class="info_content">{{ newsDetail.summary_en || "-" }}</li>
          </div>
          <div class="info" v-else-if="newsDetail.summary">
            <li class="shuxian"></li>
            <li class="info_title">摘要：</li>
            <li class="info_content">{{ newsDetail.summary }}</li>
          </div>
          <div class="main_left_item">
            <!-- <img :src="coverImgUrl" alt="" v-if="newsDetail.cover_img" /> -->
            <div class="fu_text" v-html="processedContent"></div>
            <div class="like" :class="{ liked: isLiked }" @click="handleLike">
              <img src="../assets/like.png" alt="" />
            </div>
            <div class="shengming">
              {{
                currentLang === "en"
                  ? "Disclaimer: The above content is reprinted from other media for the purpose of delivering more information. It does not represent the views of this website. If it inadvertently infringes on the copyright of the copyright owner, please contact us and this website will actively take deletion, shielding and other handling measures."
                  : "免责声明：以上内容为本网站转自其它媒体，相关信息仅为传递更多信息之目的，不代表本网观点。如无意中侵犯了著作权人的著作权，您可与本网联系，本网站将积极采取删除、屏蔽等处理。"
              }}
            </div>
          </div>
        </div>
        <div class="main_right">
          <div
            class="plate_right_item"
            v-for="item in classSonList"
            :key="item.id"
          >
            <div class="plate_right_item_title">
              <span>{{
                currentLang === "en" && item.name_en ? item.name_en : item.name
              }}</span>
            </div>
            <div class="plate_right_item_content">
              <a
                :href="item.url"
                target="_blank"
                class="plate_right_item_content_item"
              >
                <img :src="getFullUrl(item.img)" alt="" />
              </a>
            </div>
          </div>
          <div
            class="plate_right"
            style="display: flex; gap: 10px; flex-direction: column"
          >
            <div class="plate_right_item">
              <div class="plate_right_item_title">
                <span>品牌官说</span>
              </div>
            </div>
            <div class="plate_right_item_content" v-if="guanShuo[0]">
              <div class="plate_right_item_content_item">
                <img :src="getFullUrl(guanShuo[0].cover_img)" alt="" />
              </div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="item in guanShuo"
                :key="item.id"
                :class="['news1', { news2: item.is_bold }]"
                @click="goToDetail(item.id, currentLang)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BackToTop from "../components/BackToTop.vue";
import { newsDetail, newsLike } from "@/api/index";

import { initWxShare } from '@/utils/wxShare'


import { imgBaseURL } from "@/api/index";

export default {
  name: "NewsDetail",
  components: {
    BackToTop,
  },
  data() {
    return {
      newsDetail: {},
      classSonList: [],
      guanShuo: [],
      isLiked: false,
      currentLang: "zh", // 默认中文
    };
  },
  computed: {
    coverImgUrl() {
      const img = this.newsDetail.cover_img;
      if (!img) return "";
      return img.startsWith("http") ? img : imgBaseURL + img;
    },
    processedContent() {
      let content;
      if (this.currentLang === "en") {
        content = this.newsDetail.content_en || null;
      } else {
        content = this.newsDetail.content;
      }
      if (!content) return "-";
      let html = content;
      html = html.replace(/width="[^"]*"/gi, "");
      html = html.replace(/height="[^"]*"/gi, "");
      return html;
    },
  },
  created() {
    this.currentLang = this.$route.query.lang || "zh";
    this.fetchDetail();
  },
  watch: {
    "$route.params.id"(newId) {
      if (newId) {
        this.currentLang = this.$route.query.lang || "zh";
        this.fetchDetail();
      }
    },
    "$route.query.lang"(newLang) {
      this.currentLang = newLang || "zh";
    },
  },
  methods: {
    async fetchDetail() {
      const id = this.$route.params.id;
      console.log("NewsDetail - 接收到的路由 id:", id);
      try {
        const res = await newsDetail(id);
        console.log("NewsDetail - 接口返回的详情数据:", res);
        if (res.code === 1 && res.data) {
          this.newsDetail = res.data.news || {};
          this.classSonList = res.data.class_son_list || [];
          this.guanShuo = res.data.guan_shuo || [];
          this.isLiked = res.data.like_status === 1;

   
         // 设置页面标题（兼容微信浏览器）
          const pageTitle = this.currentLang === 'en' ? (this.newsDetail.title_en || this.newsDetail.title) : this.newsDetail.title;
          this.$route.meta.title = pageTitle;
          this.setDocumentTitle(pageTitle);
          // 初始化微信分享
          const shareInfo = {
            title: this.currentLang === 'en' ? (this.newsDetail.title_en || this.newsDetail.title) : this.newsDetail.title,
            desc: this.currentLang === 'en' ? (this.newsDetail.summary_en || '') : (this.newsDetail.summary || ''),
            link: 'http://www.international-brands.net/news-detail/' + id,
            imgUrl: this.newsDetail.cover_img ? (this.newsDetail.cover_img.startsWith('http') ? this.newsDetail.cover_img : imgBaseURL + this.newsDetail.cover_img) : 'http://www.international-brands.net/fenxiang.png'
          }
          initWxShare(shareInfo)
        }
      } catch (error) {
        console.error("获取详情失败:", error);
      }
    },
    async handleLike() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$message.warning(
          this.currentLang === "en" ? "Please login first" : "请先登录"
        );
        return;
      }
      const newsId = this.$route.params.id;
      try {
        const res = await newsLike(newsId);
        if (res.code === 1) {
          this.isLiked = !this.isLiked;
          this.$message.success(
            this.isLiked
              ? this.currentLang === "en"
                ? "Liked successfully"
                : "点赞成功"
              : this.currentLang === "en"
              ? "Like cancelled"
              : "取消点赞"
          );
        } else {
          this.$message.error(
            res.msg ||
              (this.currentLang === "en" ? "Operation failed" : "操作失败")
          );
        }
      } catch (error) {
        console.error("点赞失败:", error);
      }
    },
    formatTime(createTime) {
      if (!createTime) return "";
      const ts = Number(createTime);
      const timeMs = ts < 1e12 ? ts * 1000 : ts;
      const d = new Date(timeMs);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const hh = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      const ss = String(d.getSeconds()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    },
    getFullUrl(path) {
      if (!path) return "";
      return path.startsWith("http") ? path : imgBaseURL + path;
    },
    goToDetail(id, lang) {
      window.open(
        this.$router.resolve({
          name: "NewsDetail",
          params: { id: id },
          query: { lang: lang || "zh" },
        }).href,
        "_blank"
      );
    },
    setDocumentTitle(title) {
      document.title = title;
      // 微信浏览器标题更新专用技巧
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('micromessenger') > -1) {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = '/favicon.ico';
        const fn = () => {
          setTimeout(() => {
            iframe.removeEventListener('load', fn);
            document.body.removeChild(iframe);
          }, 0);
        };
        iframe.addEventListener('load', fn);
        document.body.appendChild(iframe);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.bilingual-news {
  h1 {
    margin: 0;
    padding: 0;
    font-weight: normal;
    font-size: inherit;
  }
  li {
    text-decoration: none;
    list-style: none;
  }
  .container {
    max-width: 76rem;
    margin: 0 auto;
  }
  .main_plate_news {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 446px;
    span {
      width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .news1 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #424242;
      cursor: pointer;
    }
    .news2 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #424242;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 48px 0 100px 30px;
    .main_left {
      width: 70%;
      display: flex;
      flex-direction: column;
      gap: 10px;
      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #232323;
        margin-bottom: 30px;
      }
      .information {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cccccc;
        box-sizing: border-box;
        padding: 10px;
        padding-top: 0;
        box-sizing: border-box;
        .information_left {
          display: flex;
          .time {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #232323;
            margin-right: 60px;
          }
          .laiyuan {
            display: flex;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #232323;
            span {
              color: #961c1c;
            }
          }
        }
        .information_right {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #232323;
        }
      }
      .info {
        width: 100%;
        background: #f9f9f9;
        display: flex;
        align-items: center;
        padding: 10px 15px;
        box-sizing: border-box;
        margin-bottom: 40px;
        .shuxian {
          width: 2px;
          height: 23px;
          background: #90080e;
          margin-right: 4px;
        }
        .info_title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #000000;
          margin-right: 25px;
        }
        .info_content {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #000000;
          flex: 1;
        }
      }
      .main_left_item {
        display: flex;
        flex-direction: column;
        img {
          width: 100%;
          height: 363px;
          transition: transform 0.3s ease, filter 0.3s ease;
          &:hover {
            transform: scale(1.02);
            filter: brightness(1.05);
          }
        }
        .fu_text {
          width: 100%;
          font-family: SourceHanSansSC, SourceHanSansSC;
          font-weight: 400;
          font-size: 16px;
          color: #2d2c2d;
          padding: 0 0 55px 0;
          background: #fff;
          box-sizing: border-box;
          border-bottom: 1px solid #ccc;
          line-height: 32px;
          ::v-deep {
            p {
              margin-bottom: 16px;
              line-height: 2;
            }
            img {
              max-width: 100% !important;
              width: 100% !important;
              height: auto !important;
            }
          }
        }
        .like {
          width: 140px;
          height: 70px;
          background: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 55px auto 0;
          cursor: pointer;
          &.liked {
            background: #e84040;
          }
          img {
            width: 36px;
            height: 36px;
          }
        }
        .shengming {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.3);
          margin-top: 34px;
        }
      }
    }
    .plate_right_item_content {
      display: flex;
      gap: 10px;
      .plate_right_item_content_item {
        width: 100%;
        display: block;
        overflow: hidden;
        img {
          width: 100%;
          height: 169px;
          object-fit: cover;
          transition: transform 0.3s ease, filter 0.3s ease;
          &:hover {
            transform: scale(1.05);
            filter: brightness(1.1);
          }
        }
      }
    }
    .main_right {
      width: 27%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      .plate_right_item {
        display: flex;
        flex-direction: column;
        .plate_right_item_title {
          margin-bottom: 20px;
          span {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            font-size: 20px;
            color: #000000;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .bilingual-news .main {
    padding: 30px 0 60px 20px;
    gap: 30px;
  }
  .bilingual-news .main .main_right {
    width: 30%;
  }
}

@media (max-width: 768px) {
  .bilingual-news .main {
    flex-direction: column;
    padding: 20px 15px 40px;
  }
  .bilingual-news .main .main_left {
    width: 100%;
  }
  .bilingual-news .main .main_left .title {
    font-size: 22px;
    margin-bottom: 20px;
  }
  .bilingual-news .main .main_left .information {
    flex-direction: column;
    gap: 8px;
  }
  .bilingual-news .main .main_left .information .information_left {
    flex-direction: column;
    gap: 5px;
  }
  .bilingual-news .main .main_left .information .information_left .time {
    margin-right: 0;
  }
  .bilingual-news .main .main_left .info {
    height: auto;
    min-height: 60px;
    padding: 10px 15px;
    flex-wrap: wrap;
  }
  .bilingual-news .main .main_left .info .info_title {
    font-size: 16px;
  }
  .bilingual-news .main .main_left .info .info_content {
    font-size: 14px;
  }
  .bilingual-news .main .main_left .main_left_item img {
    height: 200px;
  }
  .bilingual-news .main .main_left .main_left_item .fu_text {
    padding: 30px 20px;
    font-size: 14px;
  }
  .bilingual-news .main .main_left .main_left_item .like {
    width: 100px;
    height: 50px;
    margin: 30px auto 0;
  }
  .bilingual-news .main .main_left .main_left_item .like img {
    width: 28px;
    height: 28px;
  }
  .bilingual-news .main .main_left .main_left_item .shengming {
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .bilingual-news .main .main_right {
    display: none;
    width: 100%;
  }
  .bilingual-news .main .main_right .plate_right_item .plate_right_item_title {
    margin-bottom: 10px;
  }
  .bilingual-news
    .main
    .main_right
    .plate_right_item
    .plate_right_item_title
    span {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .bilingual-news .main {
    padding: 15px 10px 30px;
  }
  .bilingual-news .main .main_left .title {
    font-size: 18px;
  }
  .bilingual-news .main .main_left .info {
    padding: 8px 10px;
  }
  .bilingual-news .main .main_left .info .shuxian {
    height: 16px;
  }
  .bilingual-news .main .main_left .info .info_title {
    font-size: 14px;
    margin-right: 10px;
  }
  .bilingual-news .main .main_left .info .info_content {
    font-size: 12px;
  }
  .bilingual-news .main .main_left .main_left_item img {
    height: 150px;
  }
  .bilingual-news .main .main_left .main_left_item .fu_text {
    padding: 20px 10px;
    font-size: 13px;
  }
}
</style>
<style lang="scss">
@media (max-width: 768px) {
  #app:has(.bilingual-news) .app-footer {
    display: none;
  }
}

//富文本中的video设置固定大小
.main_left_item video {
  /* width: 730px !important;   强制覆盖内联 width="500" */
   /*  height: 470px !important; 强制覆盖内联 height="250" */
  max-width: 100% !important; /* 移动端自适应 */
  object-fit: cover;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
